import { API } from '../Auth';

const DISCOVER_RUNS_API = 'discoverRuns';
const LANDSCAPE_ENTITIES_PATH = '/api/v1/landscape/entities';

const MASK_STATUSES = new Set(['MASKED', 'MASKING', 'UNMASKED', 'ERROR']);
const ENCRYPT_STATUSES = new Set(['ENCRYPTED', 'ENCRYPTING', 'DECRYPTING', 'UNSECURED', 'ERROR']);

const normalizeEntitySource = (source) => ({
  dataSourceId: source?.dataSourceId != null ? source.dataSourceId : null,
  name: source?.name || '',
  engine: source?.engine || '',
  datasourceType: source?.datasourceType || 'RELATIONAL',
  instanceCount: Number.isFinite(Number(source?.instanceCount)) ? Number(source.instanceCount) : 0,
  maskStatus: MASK_STATUSES.has(source?.maskStatus) ? source.maskStatus : 'UNMASKED',
  encryptStatus: ENCRYPT_STATUSES.has(source?.encryptStatus) ? source.encryptStatus : 'UNSECURED',
});

const normalizeEntityTile = (tile) => ({
  entityType: tile?.entityType || 'UNKNOWN',
  total: Number.isFinite(Number(tile?.total)) ? Number(tile.total) : 0,
  sources: Array.isArray(tile?.sources)
    ? tile.sources.map(normalizeEntitySource).filter((s) => s.dataSourceId != null)
    : [],
});

/**
 * GET /api/v1/landscape/entities — cross-source entity roll-up recomputed at each
 * DISCOVER finalize. Counts are INSTANCE counts (the scatter-plot metric), so the tiles
 * agree with the results view. Statuses are whole-source, not per-entity. Sorted by the
 * backend (tiles by total desc, sources by instanceCount desc); re-sorted here defensively.
 * @returns {Array<{entityType, total, sources: Array<{dataSourceId, name, engine,
 *   datasourceType, instanceCount, maskStatus, encryptStatus}>}>}
 */
const getLandscapeEntities = async () => {
  const response = await API.get(DISCOVER_RUNS_API, LANDSCAPE_ENTITIES_PATH);
  const payload = response?.data ? response.data : response;
  const tiles = Array.isArray(payload) ? payload.map(normalizeEntityTile) : [];
  tiles.forEach((t) => t.sources.sort((a, b) => b.instanceCount - a.instanceCount));
  return tiles.sort((a, b) => b.total - a.total);
};

export { getLandscapeEntities, normalizeEntityTile, normalizeEntitySource };
